import { permissions } from '~/types/constants';

type INavItem = {
  label: string;
  to: string;
  permissions: permissions[];
};

export const navItems: INavItem[] = [
  {
    label: 'Processos',
    to: '/processes',
    permissions: [permissions.CREATE_REQUEST],
  },
  {
    label: 'Solicitações',
    to: '/requests',
    permissions: [permissions.VIEW_REQUEST],
  },
  {
    label: 'Execuções',
    to: '/executions',
    permissions: [permissions.VIEW_EXECUTIONS],
  },
  {
    label: 'Tarefas',
    to: '/tasks/disponiveis',
    permissions: [permissions.VIEW_ALL_TASKS],
  },
  {
    label: 'Usuários',
    to: '/users',
    permissions: [permissions.VIEW_ALL_USER],
  },
  {
    label: 'Dados',
    to: '/data',
    permissions: [permissions.VIEW_REPORTS],
  },
  {
    label: 'Cadastros',
    to: '/data-lists',
    permissions: [permissions.VIEW_ALL_DATA_LISTS],
  },
];
